import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BaseFileService } from './base-file.service';

@Injectable({
  providedIn: 'root',
})
export class ProductsSheetService extends BaseFileService {
  baseUrl = environment.apiUrl;
  SINGLE_FILE_UPLOAD_URL = this.baseUrl + '/Product/PostFile';

  constructor(@Inject(HttpClient) http) {
    super(http);
  }
}
